import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AuthModule, AUTH_SERVICE } from 'ngx-auth';

import {
  AbnService,
  AdminService,
  ClientService,
  ClientResolver,
  CustomerService,
  CustomerResolver,
  CommandService,
  CommunicationPartialResolver,
  CommunicationService,
  CommunicationTemplateResolver,
  DebtService,
  DebtResolver,
  DirectAuthService,
  LogService,
  FeeService,
  GuestUserService,
  ImportService,
  InvoiceService,
  NoteService,
  PaymentService,
  PayrunService,
  PermissionResolver,
  PermissionService,
  PromotionCodeService,
  PromotionCodeResolver,
  ReportService,
  RoleResolver,
  RoleService,
  SlodService,
  TransactionService,
  TransactionResolver,
  UserResolver,
  UserService,
} from './data';
import {
  AuthService,
  GoogleMapsService,
  PasswordService,
  SessionService,
  StorageService,
  TitleSetterService,
  TokenService,
} from './services';
import { SCOPE_KEY } from './tokens';

@NgModule({
  imports: [
    AuthModule,
    HttpClientModule,
  ],
  providers: [
    AbnService,
    AdminService,
    AuthService,
    ClientService,
    ClientResolver,
    CustomerService,
    CustomerResolver,
    CommandService,
    CommunicationPartialResolver,
    CommunicationService,
    CommunicationTemplateResolver,
    DebtService,
    DebtResolver,
    DirectAuthService,
    LogService,
    FeeService,
    GoogleMapsService,
    GuestUserService,
    InvoiceService,
    ImportService,
    NoteService,
    PasswordService,
    PaymentService,
    PayrunService,
    PermissionResolver,
    PermissionService,
    PromotionCodeService,
    PromotionCodeResolver,
    ReportService,
    RoleResolver,
    RoleService,
    SlodService,
    SessionService,
    StorageService,
    TitleSetterService,
    TokenService,
    TransactionService,
    TransactionResolver,
    UserResolver,
    UserService,
    {
      provide: AUTH_SERVICE,
      useExisting: TokenService,
    },
  ],
})
export class CoreModule {
  static forChild(scopeKey: string) {
    return {
      ngModule: CoreModule,
      providers: [
        {
          provide: SCOPE_KEY,
          useValue: scopeKey,
        },
      ],
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts